import { CommonScriptComponent } from './../common-script/common-script.component';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-web-application-dev',
  templateUrl: './web-application-dev.component.html',
  styleUrls: ['./web-application-dev.component.css']
})
export class WebApplicationDevComponent implements OnInit {

  constructor(private commonScriptComponent:CommonScriptComponent) { }

  ngOnInit() {
    this.commonScriptComponent.onLoad();
  }

}



// WEBPACK FOOTER //
// D:/Projects/Veepal/Veepal.Com/Dev/src/app/web-application-dev/web-application-dev.component.ts